import { TooltipProvider } from "../../../components/tailwind/tooltip";
import { ActionCard } from "./ActionCard";

export const QuickActionsGrid = ({ actions }) => {
    return (
        <TooltipProvider>
            <div className="animate-fade-in-up animate-delay-200">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                    Quick Actions
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                    {actions.map((action, index) => (
                        <ActionCard key={action.id} action={action} index={index} />
                    ))}
                </div>
            </div>
        </TooltipProvider>
    );
};
